import styled from '@emotion/styled'
import { Text } from 'components/Typography'
import { pxToRem } from 'utils/styled'

export const SUploadedItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--c-gray300);
  border: 2px solid var(--c-blue100);
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  padding: 8px;
  & > span {
    color: var(--c-blue500);
  }
`

export const STitle = styled(Text)`
  font-weight: bold;
  color: black;
  margin: ${pxToRem(12)}rem 0;
`
